import { Injectable } from "@angular/core";
import "leaflet";
import DriftMarker from "leaflet-drift-marker";
import { Events } from "../classes/events";
import { VanEvents } from "../classes/van-events";
import { VanEventAddEvent } from "../classes/vanEvent-addEvent";
import { LoggerService } from "./logger.service";
import { MapIconService } from "./map-icon.service";
import { MapPopUpService } from "./map-popup.service";
import { UtilitiesService } from "./utilities.service";
declare let L;

@Injectable({
  providedIn: "root",
})
export class MapMarkerService {
  vanMarkerLayerGroup: L.LayerGroup = new L.LayerGroup();
  currentVanMarkersOnMap = {};
  updateCount = 0;
  addedCount = 0;
  removedCount = 0;

  constructor(
    private mapPopUpService: MapPopUpService,
    private mapIconService: MapIconService,
    private logger: LoggerService,
    private utilityService: UtilitiesService
  ) {}




  public processVanMarkers(data: Events, animate: boolean): L.LayerGroup {
    let vanEvents: VanEvents = data.vanEvents;
    let addEvents: Array<VanEventAddEvent> = vanEvents.addEvents;
    // let deleteEvents: Array<VanEventsDeleteEvent> = vanEvents.deleteEvents;
    // let updateEvents: Array<VanEventsUpdateEvent> = vanEvents.updateEvents;
    this.updateCount = 0;
    this.addedCount = 0;
    this.removedCount = 0;
    addEvents.forEach((row: VanEventAddEvent) => {
      const id = row.vanName;
      const pos = new L.LatLng(row.latitude, row.longitude);
      if (!this.currentVanMarkersOnMap[id]) {
        // If there is no marker with this id yet, instantiate a new one.
        this.makeNewVanMarker(row, id, pos, animate);
      } else {
        // If there is already a marker with this id, only modify its position and info.
        this.updateExistingVanMarker(row, id, pos, animate);
      }
    });
    this.logger.debug(`Van Markers: Added:${this.addedCount}|Updated:${this.updateCount}|Removed:${this.removedCount}`, 'markers');
    return this.vanMarkerLayerGroup;
  }

  private makeNewVanMarker(row: VanEventAddEvent,id: string,pos: L.LatLng,animate: boolean): void {
    if (row.driverId) {
      // if the driver is logged in, make the marker
      if (!animate) {
        // animate marker is false
        this.currentVanMarkersOnMap[id] = L.marker(pos, { icon: this.mapIconService.makeVanSvgIcon(row)});
      } else {
        this.currentVanMarkersOnMap[id] = new DriftMarker(pos, { icon: this.mapIconService.makeVanSvgIcon(row) });
       // this.currentVanMarkersOnMap[id] = new DriftMarker([38.17279166141056, -85.73494434356691], { icon: this.mapIconService.makeVanSvgIcon(row) });
      }
      this.currentVanMarkersOnMap[id].bindPopup(this.mapPopUpService.makeVanPopup(row));
      this.addedCount++;
      this.vanMarkerLayerGroup.addLayer(this.currentVanMarkersOnMap[id]);
    }
  }

  private updateExistingVanMarker(row: VanEventAddEvent,id: string,pos: L.LatLng,animate: boolean): void {
    if (row.driverId === "") {
      // if the marker exists but this incoming driverId is "", remove the marker
      this.removeVanMarker(id);
    } else {
      // update the marker
      if (!animate) {
        // animate false
        this.currentVanMarkersOnMap[id].setLatLng(pos).setPopupContent(this.mapPopUpService.makeVanPopup(row));
      } else {
        // animate true
        this.currentVanMarkersOnMap[id].slideTo(pos, {duration: 14000, keepAtCenter: false}).setPopupContent(this.mapPopUpService.makeVanPopup(row));
      }
      this.updateCount++;
    }
  }

  private removeVanMarker(id: string): void {
    this.vanMarkerLayerGroup.removeLayer(this.currentVanMarkersOnMap[id]);
    delete this.currentVanMarkersOnMap[id];
    this.removedCount++;
  }


  validateLatLngs(lat,lng): boolean{
    return this.utilityService.validateLatLngs(lat,lng);
  }




}
